/*
 * login Actions
 *
 * @version 1.0.0
 * @author Pietro
 * @since 13-Sep-2024
 */

import { createRequestTypes, MakeRequest, createAction } from './index'

export const actionTypes = {
  DO_GET_TOKEN: '@@login/get_token',
  DO_GET_CARDHOLDER_NAME: '@@login/get_cardholder_name',
  DO_USER_LOGIN: '@@login/user_login',
  DO_RESET_CARDHOLDER_NAME: '@@login/reset_cardholder_name',
  DO_LOGOUT: '@@login/logout',
  DO_IAM_LOGIN: '@@login/iam_login',
  DO_RESET_IAM_LOGIN_ERROR: '@@login/reset_iam_login_error',
  DO_ROPC_TOKEN: '@@login/ropc_token',
  DO_REFRESH_TOKEN: '@@login/refresh_token',
  DO_BIOMETRIC_CHOICE: '@@login/biometric_choice',
  DO_EXTEND_SESSION: '@@login/extend_session',
  DO_GET_LOGIN_NEWS: '@@login/get_login_news',

  // @generator action:type
  ...createRequestTypes('@@login', 'USER_LOGIN'),
  ...createRequestTypes('@@login', 'GET_TOKEN'),
  ...createRequestTypes('@@login', 'LOGOUT'),
  ...createRequestTypes('@@login', 'GET_CARDHOLDER_NAME'),
  ...createRequestTypes('@@login', 'IAM_LOGIN'),
  ...createRequestTypes('@@login', 'ROPC_TOKEN'),
  ...createRequestTypes('@@login', 'REFRESH_TOKEN'),
  ...createRequestTypes('@@login', 'EXTEND_SESSION'),
  ...createRequestTypes('@@login', 'GET_LOGIN_NEWS')
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Insert a description
 * @name getToken
 * @return {object} - The action object
 */
export const getToken = new MakeRequest('login', 'get_token')
/** @action request
 * * Insert a description
 * @name userLogin
 * @return {object} - The action object
 */
export const userLogin = new MakeRequest('login', 'user_login')
/** @action request
 * * Insert a description
 * @name logout
 * @return {object} - The action object
 */
export const logout = new MakeRequest('login', 'logout')
/** @action request
 * * Insert a description
 * @name getCardHolderName
 * @return {object} - The action object
 */
export const getCardHolderName = new MakeRequest('login', 'get_cardholder_name')
/** @action request
 * * Insert a description
 * @name iamLogin
 * @return {object} - The action object
 */
export const iamLogin = new MakeRequest('login', 'iam_login')
/** @action request
 * * Insert a description
 * @name ropcToken
 * @return {object} - The action object
 */
export const ropcToken = new MakeRequest('login', 'ropc_token')
/** @action request
 * * Insert a description
 * @name refreshToken
 * @return {object} - The action object
 */
export const refreshToken = new MakeRequest('login', 'refresh_token')
/** @action request
 * * Insert a description
 * @name extendSession
 * @return {object} - The action object
 */
export const extendSession = new MakeRequest('login', 'extend_session')
/** @action request
 * * Insert a description
 * @name getLoginNews
 * @return {object} - The action object
 */
export const getLoginNews = new MakeRequest('login', 'get_login_news')

// @generator action:request

/** @action
 * * Insert a description
 * @name Logout
 * @return {object} - The payload object
 */
export const doLogout = payload => createAction(actionTypes.DO_LOGOUT, { payload })
/** @action
 * * Insert a description
 * @name CardHolderName
 * @return {object} - The payload object
 */
export const doGetCardHolderName = payload => createAction(actionTypes.DO_GET_CARDHOLDER_NAME, { payload })
/** @action
 * * Insert a description
 * @name GetToken
 * @return {object} - The payload object
 */
export const doGetToken = payload => createAction(actionTypes.DO_GET_TOKEN, { payload, isSca: true })

/** @action
 * * Insert a description
 * @name UserLogin
 * @return {object} - The payload object
 */
export const doUserLogin = payload => createAction(actionTypes.DO_USER_LOGIN, { payload })
/** @action
 * * Insert a description
 * @name ResetCardHolderName
 * @return {object} - The payload object
 */
export const doResetCardHolderName = payload => createAction(actionTypes.DO_RESET_CARDHOLDER_NAME, { payload })

/** @action
 * * Insert a description
 * @name IamLogin
 * @return {object} - The payload object
 */
export const doIamLogin = payload => createAction(actionTypes.DO_IAM_LOGIN, { payload })

/** @action
 * * Insert a description
 * @name ResetIamLoginError
 * @return {object} - The payload object
 */
export const doResetIamLoginError = payload => createAction(actionTypes.DO_RESET_IAM_LOGIN_ERROR, { payload })

/** @action
 * * Insert a description
 * @name RopcToken
 * @return {object} - The payload object
 */
export const doRopcToken = payload => createAction(actionTypes.DO_ROPC_TOKEN, { payload })

/** @action
 *
 * @name RefreshToken
 * @return {object} - The payload object
 */
export const doRefreshToken = payload => createAction(actionTypes.DO_REFRESH_TOKEN, { payload })

/** @action
 *
 * @name BiometricChoice
 * @return {object} - The payload(choice) object
 */
export const doBiometricChoice = payload => createAction(actionTypes.DO_BIOMETRIC_CHOICE, { payload })

/** @action
 *
 * @name ExtendSession
 * @return {object} - The payload object
 */
export const doExtendSession = payload => createAction(actionTypes.DO_EXTEND_SESSION, { payload })

/** @action
 *
 * @name GetLoginNews
 * @return {object} - The payload object
 */
export const doGetLoginNews = payload => createAction(actionTypes.DO_GET_LOGIN_NEWS, { payload })
// @generator action
